import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/sharedModule/shared.module';
import { ExtensionGroupsComponent } from './extension-groups.component';

@NgModule({
  declarations: [ExtensionGroupsComponent],
  imports: [CommonModule, SharedModule],
  exports: [ExtensionGroupsComponent],
})
export class ExtensionGroupsModule {}
